import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { space, borderRadius, fontSizes } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const modalBody = style({
  display: 'flex',
  flexDirection: 'column',
  padding: `0 ${space.s20}px ${space.s16}px`,
  gap: space.s12,
  maxHeight: 400,
});

export const searchInput = style({
  selectors: {
    '&:is(&)': {
      minHeight: 0,
      height: 36,
    },
  },
});

export const symbolsList = style({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  flex: 1,
});

export const groupLabel = style({
  fontSize: fontSizes.labelSm,
  fontWeight: 600,
  color: themeVars.container.foreground.secondary,
  padding: `${space.s8}px ${space.s8}px ${space.s4}px`,
  position: 'sticky',
  top: 0,
  background: themeVars.container.primary.background.idle,
  zIndex: 1,
});

export const symbolItem = style([
  typography.bodySm,
  {
    display: 'flex',
    alignItems: 'center',
    padding: `${space.s6}px ${space.s8}px`,
    color: themeVars.container.foreground.primary,
    textDecoration: 'none',
    borderRadius: borderRadius.r8,
    cursor: 'pointer',
    ':hover': {
      background: themeVars.container.primary.background.hover,
    },
  },
]);

export const spinnerWrapper = style({
  display: 'flex',
  justifyContent: 'center',
  padding: space.s20,
});

export const truncatedHint = style({
  fontSize: fontSizes.labelSm,
  color: themeVars.container.foreground.secondary,
  textAlign: 'center',
  padding: `${space.s8}px 0`,
});

export const viewPriceChartButton = style({
  width: 'fit-content',
});
